import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Select, MenuItem, FormControl, InputLabel,
  TextField, Typography
} from "@mui/material";
import { putData } from "../../BaseUrl";

const SwitchDialog = ({ open, onClose, student, sections, onSuccess }) => {
  const [targetSectionId, setTargetSectionId] = useState("");
  const [targetStudentId, setTargetStudentId] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const otherSections = sections.filter(s => s.id !== student?.currentSectionId);
  const targetSection = otherSections.find(s => s.id === parseInt(targetSectionId));
  const targetStudents = targetSection?.enrollments?.map(en => en.application) || [];

  const handleSubmit = async () => {
    if (!targetStudentId) { setError("Please select a student to switch with"); return; }

    setLoading(true);
    setError("");
    try {
      await putData("admin/admission/sections/switch", {
        applicationId1: student.id,
        applicationId2: parseInt(targetStudentId),
        reason
      });
      onSuccess("Students switched successfully");
      resetForm();
    } catch (err) {
      setError(err?.message || "Switch failed");
    }
    setLoading(false);
  };

  const resetForm = () => { setTargetSectionId(""); setTargetStudentId(""); setReason(""); setError(""); };

  return (
    <Dialog open={open} onClose={() => { onClose(); resetForm(); }} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>Switch Students</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={2}>
          {student?.firstName} {student?.lastName} | Current: {student?.currentSection}
        </Typography>

        <FormControl fullWidth size="small" sx={{ mb: 2 }}>
          <InputLabel>Select Target Section</InputLabel>
          <Select value={targetSectionId} label="Select Target Section"
            onChange={(e) => { setTargetSectionId(e.target.value); setTargetStudentId(""); }}>
            {otherSections.map(sec => (
              <MenuItem key={sec.id} value={sec.id}>
                {sec.displayName} ({sec.enrolledCount} students)
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {targetSectionId && (
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Select Student to Switch With *</InputLabel>
            <Select value={targetStudentId} label="Select Student to Switch With *"
              onChange={(e) => setTargetStudentId(e.target.value)}>
              {targetStudents.map(s => (
                <MenuItem key={s.id} value={s.id}>
                  {s.firstName} {s.lastName} ({s.registrationNumber})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <TextField size="small" fullWidth multiline rows={2} label="Reason (Optional)"
          value={reason} onChange={(e) => setReason(e.target.value)} />

        {error && <Typography color="error" variant="body2" mt={2}>{error}</Typography>}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={() => { onClose(); resetForm(); }} variant="outlined" color="inherit">Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}
          sx={{ background: "linear-gradient(90deg, #4A7BA8, #244C77)" }}>
          {loading ? "Switching..." : "Confirm Switch"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SwitchDialog;
